import {
  ChevronDoubleLeftIcon,
  ChevronDoubleRightIcon,
} from '@heroicons/react/24/outline';
import React from 'react';
import { twMerge } from 'tailwind-merge';

interface SidebarProps {
  wrapperClassNames?: string;
  sidebarClassNames?: string;
  isSidebarOpen: boolean;
  setIsSidebarOpen: (isSidebarOpen: boolean) => void;
  children: React.ReactNode;
}

const CollapsibleSidebar = ({
  wrapperClassNames,
  sidebarClassNames,
  isSidebarOpen,
  setIsSidebarOpen,
  children,
}: SidebarProps) => {
  const sidebarWrapperClassNames = twMerge(
    'h-full',
    'hidden',
    'md:flex',
    'md:flex-col',
    'md:float-left',
    'md:transition-[width] md:duration-300 md:ease-in-out',
    isSidebarOpen ? 'w-80' : 'w-14',
    `${wrapperClassNames ?? ''}`
  );

  const sidebarContainerClassNames = twMerge(
    'flex-1',
    'flex',
    'flex-col',
    'min-h-0',
    'border-r',
    'border-gray-200',
    'bg-white',
    'py-4',
    '2xl:my-8',
    '2xl:p-2',
    '2xl:border',
    '2xl:rounded-lg',
    '2xl:shadow-md',
    'overflow-y-auto',
    'overflow-x-hidden',
    'transition-transform duration-300 ease-in-out',
    isSidebarOpen ? 'scale-x-100' : 'scale-x-200',
    `${sidebarClassNames ?? ''}`
  );

  return (
    <div className={sidebarWrapperClassNames}>
      <div className={sidebarContainerClassNames}>
        <div className="scrollbar-hide mb-4 h-full overflow-x-hidden overflow-y-scroll">
          {children}
        </div>
        <button
          type="button"
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          className="flex-end mx-4 flex h-6 w-6 cursor-pointer focus:outline-none 2xl:hidden"
        >
          {isSidebarOpen ? (
            <ChevronDoubleLeftIcon className="h-5 w-5 text-kira-slate-700" />
          ) : (
            <ChevronDoubleRightIcon className="h-5 w-5 text-kira-slate-700" />
          )}
        </button>
      </div>
    </div>
  );
};

export default CollapsibleSidebar;
